.justify-center {
  justify-content: center;
  text-align: center;
}

.total-cost-cell {
  justify-content: flex-end;
}

.total-cost-column {
  width: 100%;
  text-align: right;
}

.product-column-header[role='columnheader'] {
  padding-left: 80px;
}

.inbound-header {
  display: flex;
  gap: 4px;
  align-items: center;
}

.info-icon {
  height: 12px;
  color: var(--primary--icon--fill-color--3);
}

.tooltip-text {
  max-width: 250px;
}

.inbound-cell {
  color: var(--primary--font--color--3);
}

.inbound-spinner {
  height: 12px;
  color: var(--primary--icon--fill-color--3);
}
